import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import useApiGet from '../hooks/getData';

function RoomGiftHistory({ open, handleClose, room }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getData } = useApiGet();

  useEffect(() => {
    if (!open || !room?.id) return;
    const fetchHistory = async () => {
      setLoading(true);
      try {
        const res = await getData(`/rooms/${room.id}/gift-history`);
        setHistory(res?.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [open, room]);

  const totalCoins = history.reduce((sum, h) => sum + (h.coin_cost || 0), 0);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogContent className="dark:bg-primary">
        <div className="flex items-center justify-between pb-4 border-b border-gray-200 dark:border-[#1F1F1F]">
          <div>
            <h2 className="text-lg font-semibold font-poppins text-[#000000] dark:text-darkText">
              {room?.name} — Coin History
            </h2>
            <p className="text-xs font-poppins text-[#777777]">
              Total: <span className="font-semibold text-[#E89A00]">🪙 {totalCoins}</span>
            </p>
          </div>
          <button onClick={handleClose} className="text-2xl text-gray-400 hover:text-gray-600">×</button>
        </div>

        <div className="mt-3 max-h-[420px] overflow-y-auto custom-scrollbar">
          {loading ? (
            <p className="py-10 text-sm text-center font-poppins dark:text-darkText">Loading...</p>
          ) : history.length > 0 ? (
            history.map((h) => (
              <div key={h.id} className="flex items-center justify-between py-3 border-b border-gray-100 dark:border-[#1F1F1F]">
                <div className="flex items-center gap-3">
                  <img src={h.sender_avatar} alt={h.sender_name} className="object-cover w-9 h-9 rounded-full bg-gray-100" />
                  <div>
                    <p className="text-sm font-medium font-poppins text-[#00162e] dark:text-darkText">
                      {h.sender_name || `User #${h.sender_id}`}
                    </p>
                    <p className="text-xs font-poppins text-[#777777]">
                      {new Date(h.created_at.replace(' ', 'T')).toLocaleString()}
                    </p>
                  </div>
                </div>
                <span className="px-3 py-1 text-sm font-semibold text-[#E89A00] bg-[#E89A00] bg-opacity-15 rounded-lg font-poppins">
                  🪙 {h.coin_cost}
                </span>
              </div>
            ))
          ) : (
            <p className="py-10 text-sm text-center font-poppins text-[#777777]">No gifts sent in this room yet</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default RoomGiftHistory;